const baseUrl = process.env.NODE_ENV === "production" ? '' : 'http://127.0.0.1:8000';

export const API_URL = baseUrl;
